<template>
	<app>
		<crumb-bar :current="detail.title"></crumb-bar>
		<module>
			<h1 class="notice-title">{{detail.title}}</h1>
			<div v-html="detail.content" class="notice-content"></div>
		</module>
	</app>
</template>

<script>
	export default {
		props: {
			id: String
		},
		
		data() {
			return {
				detail: {}
			}
		},
		
		mounted() {
			this.request({
				url: '/announcement/detail',
				data: {
					id: this.id
				},
				success: data => {
					this.detail = data;
				}
			});
		}
	}
</script>

<style lang="stylus" scoped>
	.notice {
		&-title {
			padding: 60px 32px 20px;
			line-height: 28px;
			font-size: 20px;
			text-align: center;
			color: #000;
			
			elder({
				line-height: 48px,
				font-size: 30px
			})
		}
		
		&-content {
			min-height: 500px;
			padding: 32px;
			line-height: 22px;
			font-size: 14px;
			
			elder({
				line-height: 36px,
				font-size: 24px
			})
		}
	}
</style>
